import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyB8TedVhBBStnUVt0xB2hr-30mYPJgLzXo",
  authDomain: "aurora-80621.firebaseapp.com",
  databaseURL: "https://aurora-80621.firebaseio.com",
  projectId: "aurora-80621",
  storageBucket: "aurora-80621.appspot.com",
  messagingSenderId: "858278320983"
};

const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({ timestampsInSnapshots: true })

// export firestore database so we can import and interact with the DB
export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/store/firebaseinit.js